export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/tattoo_design.b95237b.svg";